<template>
	<div class="container mx-auto max-w-5xl px-4">
		<div class="flex flex-col justify-between">
			<div class="flex overflow-hidden p-2">
				<HelpfulTips>
					Please select all that are true. For example, if your windshield has a crack,
					select “Damage to glass.” If your ride does not have any issues that you know of
					please select “none.”
					<br />
					Please use the comments box to tell us more about your ride's cosmetic condition
					if there are other important details.
				</HelpfulTips>

				<div class="grow basis-1/2 overflow-y-auto px-4">
					<div
						v-for="option in form.moreDamagedList"
						:key="option.id"
						class="hover:border-main-300 hover:bg-main-300 group mb-4 box-border flex cursor-pointer flex-col rounded-xl border border-gray-300 py-4 pl-3 pr-6"
						:class="{
							'border-main-400 bg-main-400': form.moreDamagedItems.some(
								mdo => mdo.id === option.id,
							),
						}"
						@click="toggleOption(option)"
					>
						<div
							class="text-main-400 flex h-10 select-none items-center text-2xl font-bold group-hover:text-white"
							:class="{
								'!text-white': form.moreDamagedItems.some(
									mdo => mdo.id === option.id,
								),
							}"
						>
							<CheckSecondSvg
								class="fill-warning mr-2 h-7 w-7"
								:class="{
									'opacity-0': !form.moreDamagedItems.some(
										mdo => mdo.id === option.id,
									),
								}"
							/>
							{{ option.name }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { QuizItem, useFormStore } from '../../../stores/form'
	import CheckSecondSvg from '../components/icons/CheckSecondSvg.vue'
	import HelpfulTips from '../components/HelpfulTips.vue'

	const form = useFormStore()

	const toggleOption = (option: QuizItem): void => {
		const index = form.moreDamagedItems.findIndex(qs => qs.id === option.id)
		if (~index) {
			form.moreDamagedItems.splice(index, 1)
		} else {
			form.moreDamagedItems.push(option)
		}
	}
</script>
